function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import { createTheming, createUseStyles } from 'react-jss';
/** Create a React context which JSS would need to wrap on */
var SurveyThemeContext = /*#__PURE__*/React.createContext({});
SurveyThemeContext.displayName = 'SurveyTheme';

/** Use JSS custom hook to create the wrapper */
var theming = createTheming(SurveyThemeContext);

/** Expose the associated hooks with aliases */
var useSurveyTheme = theming.useTheme,
  SurveyThemeProvider = theming.ThemeProvider;

/** Recreation of `react-jss`'s `CreateUseStylesOptions`, which is dynamic and does not get exported */
export { useSurveyTheme, SurveyThemeProvider };
/**
 * For convenience, expose a custom hook which would carry the theming context wrapper along,
 * as well as injecting style sheet name-space / class name prefix as "sm" by default.
 *
 * Note: One may still utilize the stock `createUseStyles()` hook to construct styles regardless
 * relying on a survey theme or not; however if they do, please keep in mind that the recommended
 * way per JSS documentation is to pass in `theming` context wrapper every time.
 * ( https://cssinjs.org/react-jss/?v=v10.8.1#using-custom-theming-context )
 *
 */
export var createSurveyStyles = function createSurveyStyles(styles) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return createUseStyles(styles, _objectSpread({
    theming: theming,
    name: 'sm'
  }, opts));
};

/**
 * The context wrapper constructed by JSS `createTheming()` hook.
 * Note: `theming.context` points to the same SurveyThemeContext we just instantiated
 */
export default theming;
//# sourceMappingURL=context.js.map